import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { Simulation } from '@classes/simulation/simulation';
import { SimulationService } from '@services/simulation.service';
import { ApiText } from '@classes/api-text';

@Component({
    selector: 'app-save-simulation-form',
    templateUrl: './save-simulation-form.component.html',
    styleUrls: ['./save-simulation-form.component.scss']
})
export class SaveSimulationFormComponent implements OnInit {
    @Input() simulation: Simulation;
    @Output() hideForm = new EventEmitter<void>();

    isFormVisible = false;
    saveSimuForm: FormGroup;

    constructor(private simuSrv: SimulationService) { }

    ngOnInit() {
        this.initForm();
    }

    onSubmit(isUpdate: boolean): void {
        this.simulation.userText = this.saveSimuForm.value;

        if(isUpdate) {
            this.simuSrv.put(this.simulation);
        } else {
            this.simuSrv.post(this.simulation);
        }
        this.hideForm.emit();
    }

    onCancel(): void {
        this.hideForm.emit();
    }

    private initForm(): void {
        let defaultText: ApiText = {
            shortLabel: ''
        };

        if(this.simulation.userText) {
            defaultText = this.simulation.userText;
        }

        this.saveSimuForm = new FormGroup({
            shortLabel: new FormControl(
                defaultText.shortLabel,
                {
                    validators: [
                        Validators.required,
                        Validators.minLength(5),
                        Validators.maxLength(25)
                    ]
                }
            ),
            summary: new FormControl(defaultText.summary)
        });
    }
}
